import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function fakturNotaJasa() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_dashboard/faktur_nota_jasa`, options)
    .then(response => {
      //let dashboard = jsona.deserialize(response.data);
      return response.data;
    });
}


function fakturNotaPart() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_dashboard/faktur_nota_part`, options)
    .then(response => {
      //let dashboard = jsona.deserialize(response.data);
      return response.data;
    });
}

function procurementOrder() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_dashboard/procurement_order`, options)
    .then(response => {
      //let dashboard = jsona.deserialize(response.data);
      return response.data;
    });
}



function repairStatus() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_dashboard/repair_status`, options)
    .then(response => {
      //let dashboard = jsona.deserialize(response.data);
      return response.data;
    });
}

function traceHold() {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/workshop/workshop_spare_part_masters?filter[stock_menipis]=true`, options)
    .then(response => {
      let dashboard = jsona.deserialize(response.data);
      return dashboard;
    });
}








export default {
  fakturNotaJasa,
  fakturNotaPart,
  procurementOrder,
  repairStatus,
  traceHold
};

